export function createModuleAuditLogger({
  service,
  getUserID,
  moduleName,
  entityName,
  getContext,
}) {
  if (!service || typeof service.audit !== "function") {
    throw new Error("Audit service with method audit(payload, requestID) is required");
  }

  const safeObject = (value) => {
    if (!value || typeof value !== "object") return null;
    return value;
  };

  const buildPayload = ({
    actionType,
    documentID,
    documentCode,
    isAdminAction,
    hasElevatedPermission,
    changes,
    metadata,
  }) => {
    const context = safeObject(typeof getContext === "function" ? getContext() : null);

    return {
      moduleName,
      entityName,
      actionType,
      documentID: documentID || 0,
      documentCode: documentCode || null,
      isAdminAction: Boolean(isAdminAction),
      hasElevatedPermission: Boolean(hasElevatedPermission),
      changeSetJson: changes && changes.length ? JSON.stringify(changes) : null,
      metadataJson: JSON.stringify({
        ...(context || {}),
        ...(metadata || {}),
      }),
    };
  };

  const track = async (entry) => {
    try {
      const requestID = Number(getUserID && getUserID());
      if (!requestID || !entry || !entry.actionType) return;

      const payload = buildPayload(entry);
      await service.audit(payload, requestID);
    } catch (_) {
      // El flujo principal no debe romper por auditoria.
    }
  };

  return { track };
}
